import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Center,
  Input,
  Icon,
  Td,
  Spinner,
  Button,
  Badge,
  HStack,
  useToast,
  Text,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import React from "react";
import { FaSadTear } from "react-icons/fa";
import UserRow from "../../../components/userRow";
import { getUsers } from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/reducer/rootReducer";
import { User } from "../../../utils/types/user";
import { AppDispatch } from "../../../redux/store";
import { color } from "../../../utils/theme";
import { TableColumn } from "react-data-table-component";
import { respondUserRequest } from "../../../services/respondUserRequest";
import DataTableBase from "../../../components/data-table/data-table";
import RejectUserModal from "../../../components/userRow/rejectModal";

const MohUserManagement: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [approvingUserId, setApprovingUserId] = useState<number | null>(null);
  const [rejectingUserId, setRejectingUserId] = useState<number | null>(null);
  const [pending, setPending] = useState(false);
  const [isRejecting, setIsRejecting] = useState(false);
  const [verifyingUserId, setVerifyingUserId] = useState<number | null>(null);
  const [selectedUser, setSelectedUser] = useState<User | null>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toast = useToast();
  const users: any[] = useSelector((state: RootState) => state.users.users);
  const [refreshTable, setRefreshTable] = useState(false);
  const [rows, setRows] = useState<any[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<User[]>([]);
  const [isRejectingModalOpen, setIsRejectingModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any | null>(null);
  const [rejectionReason, setRejectionReason] = useState("");
  const currentUser: User | null = useSelector(
    (state: RootState) => state.user.user
  );
  const baseUrl = "http://196.188.175.178:8008";
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const reloadTable = () => {
    dispatch(getUsers());
  };
  const approveUser = (userId: number, approval_requests: any) => {
    setApprovingUserId(userId);
    setTimeout(() => {
      respondUserRequest(userId, approval_requests[0].id, "Confirmed")
        .then((res) => {
          setApprovingUserId(null);
          toast({
            title: "User Approved",
            position: "top-right",
            description: "User has been approved successfully",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          reloadTable();
        })
        .catch((error) => {
          setApprovingUserId(null);
          toast({
            title: "User Approval Failed",
            position: "top-right",
            description: "please try again",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        });
    }, 3000);
  };
  const openDocument = (user: User) => {
    console.log("selected user: ", user);

    setSelectedUser(user);
    setIsDrawerOpen(true);
  };
  const rejectUser = (userId: number, approval_requests: any) => {
    setRejectingUserId(userId);
    setTimeout(() => {
      respondUserRequest(userId, approval_requests[0].id, "Rejected")
        .then((res) => {
          setRejectingUserId(null);
          toast({
            title: "User Rejected",
            position: "top-right",
            description: "User has been rejected successfully",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          reloadTable();
        })
        .catch((error) => {
          setRejectingUserId(null);
          toast({
            title: "User Rejection Failed",
            position: "top-right",
            description: "please try again",
            status: "error",
            duration: 5000,
            isClosable: true,
          });
        });
    }, 3000);
  };
  const verifyUser = (userId: number, approval_requests: any) => {
    setVerifyingUserId(userId);
    setTimeout(() => {
      respondUserRequest(userId, approval_requests[0].id, "Verified")
        .then((res) => {
          setVerifyingUserId(null);
          toast({
            title: "User verified",
            position: "top-right",
            description: "User has been verified successfully",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
          reloadTable();
        })
        .catch((error) => {
          setApprovingUserId(null);
          toast({
            title: "User verification Failed",
            position: "top-right",
            description: "please try again",
            status: "success",
            duration: 5000,
            isClosable: true,
          });
        });
    }, 3000);
  };
  const deactivateUser = (user: User) => {
    console.log("user deactivated");
  };

  useEffect(() => {
    setPending(true);
    dispatch(getUsers());
  }, [dispatch]);

  useEffect(() => {
    setPending(true);
    setIsLoading(true);
    let data = users
      .filter((user: User) => {
        return (
          user.role?.code === "FACAD" && user.approval_requests.length !== 0
        );
      })
      .map((user: User) => {
        return {
          id: user.id,
          fullname: user?.first_name + " " + user?.last_name,
          phone_number: user?.phone_number,
          facility: user?.facility.name,
          position: user?.position,
          status: user?.approval_requests[0].status,
          document: user?.approval_document,
          approval_requests: user?.approval_requests,
        };
      });
    setRows(data);
    setFilteredUsers(
      users.filter((user: User) => {
        return (
          user.role?.code === "FACAD" && user.approval_requests.length !== 0
        );
      })
    );
    setIsLoading(false);
    setPending(false);
  }, [users]);
  useEffect(() => {
    setPending(true);
    setIsLoading(true);
    dispatch(getUsers());
    let data = users
      .filter((user: User) => {
        return (
          user.role?.code === "FACAD" && user.approval_requests.length !== 0
        );
      })
      .map((user: User) => {
        return {
          id: user.id,
          fullname: user?.first_name + " " + user?.last_name,
          phone_number: user?.phone_number,
          facility: user?.facility.name,
          position: user?.position,
          status: user?.approval_requests[0].status,
          document: user?.approval_document,
          approval_requests: user?.approval_requests,
        };
      });
    setRows(data);
    setFilteredUsers(
      users.filter((user: User) => {
        return (
          user.role?.code === "FACAD" && user.approval_requests.length !== 0
        );
      })
    );
    setIsLoading(false);
    setPending(false);
  }, [refreshTable]);
  type DataRow = {
    id: number;
    fullname: string;
    phone_number: string;
    facility: string;
    position: string;
    status: string;
    document: string;
    action: string;
    approval_requests: any[];
  };
  const columns: TableColumn<DataRow>[] = [
    {
      name: "#",
      selector: (row) => row.id,
      width: "50px",
    },
    {
      name: "Full Name",
      selector: (row) => row.fullname,
      sortable: true,
    },
    {
      name: "Phone Number",
      selector: (row) => row.phone_number,
      sortable: true,
    },
    {
      name: "Facility",
      width: "250px",
      selector: (row) => row.facility,
      sortable: true,
    },
    {
      name: "Position",
      selector: (row) => row.position,
      sortable: true,
    },
    {
      name: "Status",

      selector: (row) => row.status,
      cell: (row) => (
        <Badge
          p={1}
          colorScheme={
            row.status === "Confirmed"
              ? "green"
              : row.status === "Pending" || row.status === "Verified"
              ? "blue"
              : "red"
          }
        >
          {row.status}
        </Badge>
      ),
      sortable: true,
    },
    {
      name: "Document",

      selector: (row) => row.status,
      cell: (row) => (
        <Button
          colorScheme="blue"
          fontWeight={"bold"}
          variant={"link"}
          fontSize={14}
          onClick={() => {
            console.log("selected user: ", filteredUsers, "row id: ", row.id);

            openDocument(
              filteredUsers.filter((user: User) => user.id === row.id)[0]
            );
          }}
        >
          View Doc.
        </Button>
      ),
      sortable: true,
    },
    {
      name: "",
      width: "200px",
      button: true,
      cell: (row) => (
        <Box my={1} minH={"35px"}>
          {(row.approval_requests[0]?.status === "Pending" || row.approval_requests[0]?.status === "Verified" ) && (
            <HStack spacing={2}>
              <Button
                colorScheme="green"
                isLoading={approvingUserId === row.id}
                w={"full"}
                onClick={() => approveUser(row.id, row.approval_requests)}
              >
                Approve
              </Button>
              <Button
                colorScheme="blue"
                isLoading={verifyingUserId === row.id}
                w={"full"}
                onClick={() => verifyUser(row.id, row.approval_requests)}
              >
                Verify
              </Button>
              <Button
                colorScheme="red"
                isLoading={rejectingUserId === row.id}
                w={"full"}
                onClick={() => {
                  setSelectedRow(row);
                  setIsRejectingModalOpen(true);
                }}
              >
                Reject
              </Button>
            </HStack>
          )}
        </Box>

        // <Button
        //   colorScheme="green"
        //   w={"100%"}
        //   mx={2}
        //   h={"80%"}
        //   fontSize={13}
        //   onClick={() => {
        //     fetchProjectDetils(row.id);
        //   }}
        // >
        //   View
        // </Button>
      ),
      sortable: false,
    },
  ];
  return (
    <>
      <RejectUserModal
        isOpen={isRejectingModalOpen}
        onClose={() => setIsRejectingModalOpen(false)}
        onSubmit={() =>
          rejectUser(selectedRow.id, selectedRow.approval_requests)
        }
        setReason={(reason: string) => {
          console.log(" reason", reason);
          setRejectionReason(reason);
        }}
      />
      <Drawer
        isOpen={isDrawerOpen}
        placement="right"
        onClose={handleCloseDrawer}
        size={"full"}
      >
        <DrawerOverlay>
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader textAlign={"center"}>
              User Verification letter
            </DrawerHeader>
            <DrawerBody>
              {selectedUser && (
                <Center h={"90%"}>
                  <embed
                    src={`${baseUrl}/${selectedUser.approval_requests[0]?.approval_document?.name}`}
                    width="90%"
                    height="100%"
                  />
                </Center>
              )}
            </DrawerBody>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
      <Box
        display={"flex"}
        w={"100%"}
        mx={"auto"}
        alignSelf={"center"}
        flexDirection={"column"}
        justifyContent={"center"}
        alignContent={"center"}
        textAlign={"left"}
        mt={5}
      >
        {/* <Thead>
          <Tr fontWeight={"500"} paddingTop={10}>
            <Th>Full Name</Th>
            <Th>Email</Th>
            <Th>Phone Number</Th>
            <Th>Facility</Th>
            <Th>Position</Th>
            <Th>Account status</Th>
            <Th>Document</Th>
            <Th>Action</Th>
          </Tr>
        </Thead>
        <Tbody>
          {isLoading === true ? (
            <Tr>
              <Td colSpan={9}>
                <Center flexDirection={"column"} gap={3}>
                  <Spinner size={"sm"} color={color.primary} />
                  Fetching users....
                </Center>
              </Td>
            </Tr>
          ) : (
            <>
              {filteredUsers.length !== 0 &&
                filteredUsers.map((user, index) => (
                  <UserRow
                    role="facility"
                    key={user.id}
                    index={index}
                    user={user}
                    refreshTable={() => {
                      setRefreshTable(!refreshTable);
                    }}
                  />
                ))}
              {filteredUsers.length === 0 && (
                <Tr fontWeight={"normal"} fontSize={14}>
                  <Td colSpan={9}>
                    <Center
                      display={"flex"}
                      flexDirection={"column"}
                      fontWeight="bold"
                      w={"100%"}
                      mt={10}
                    >
                      <Box as="span" mr={2} fontSize="xl">
                        <Icon as={FaSadTear} color={color.primary} size={80} />
                      </Box>
                      No users Found.
                    </Center>
                  </Td>
                </Tr>
              )}
            </>
          )}
        </Tbody> */}

        <DataTableBase
          title="Facility Admin Users"
          columns={columns}
          data={rows.sort((a, b) => b.id - a.id)}
          progressPending={pending}
          progressComponent={
            <Box
              mt={20}
              display={"flex"}
              flexDirection={"column"}
              justifyContent={"center"}
              alignContent={"center"}
              alignItems={"center"}
              gap={4}
            >
              <Spinner
                title="Getting existing challenges"
                color={color.primary}
              />
              <Text color={color.text} fontSize={16}>
                Fetching Users
              </Text>
            </Box>
          }
          dense
          pagination
        />
      </Box>
    </>
  );
};

export default MohUserManagement;
